import React from "react";
import { observer } from "mobx-react";
import "./PendingJobs.scss";
import useTranslation from "../../../hooks/useTranslation";
import PendingCases from "./PendingCases";
import PendingOffers from "./PendingOffers";
import PendingRegistrations from "./PendingRegistrations";
import configStore, { Flags } from "../../../stores/ConfigStore";

const PendingJobs = observer(() => {
  const { t } = useTranslation();

  return (
    <div className="pendingJobsContainer">
      <section className={"mt pt"}>
        <h2 className={"mb pb"}>{t("approval-pending-cases")}</h2>
        <PendingCases />
      </section>
      {configStore.getFlag(Flags.isOfferApprovalRequired) && (
        <section className={"mt pt"}>
          <h2 className={"mb pb"}>{t("approval-pending-offers")}</h2>
          <PendingOffers />
        </section>
      )}
      <section className={"mt pt"}>
        <h2 className={"mb pb"}>{t("approval-pending-lawyers")}</h2>
        <PendingRegistrations />
      </section>
    </div>
  );
});

export default PendingJobs;
